import {SearchIcon} from '@heroicons/react/outline';

import {Input} from '@/components/common/Input';

type TableSearchInputProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
};

/**
 * A live, client-side filter box for a table whose full dataset is already in
 * memory (unlike `SearchBar`, which submits a term to a server-paginated
 * list). No submit button: every keystroke re-filters the in-memory list, so
 * there is nothing to submit.
 */
const TableSearchInput = ({
  value,
  onChange,
  placeholder = 'Search...',
  className,
}: TableSearchInputProps) => {
  return (
    <Input
      type="search"
      value={value}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
        onChange(e.target.value)
      }
      placeholder={placeholder}
      aria-label={placeholder}
      autoComplete="off"
      leftIcon={<SearchIcon className="h-4 w-4 text-gray-400" />}
      className={`w-full sm:w-64 ${className ?? ''}`}
    />
  );
};

export default TableSearchInput;
